import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = ["Gravação", "Escrita de Letras", "Produção Musical", "Mix & Master", "Videoclips", "Design & Artwork", "Distribuição & Promoção", "Networking & Booking"];

export default function MarqueeBar() {
  return (
    <section data-testid="marquee-bar" className="relative bg-lime py-6 overflow-hidden border-y-2 border-ink">
      <Marquee speed={50} gradient={false} pauseOnHover>
        {WORDS.concat(WORDS).map((w, i) => (
          <span
            key={i}
            className="font-display font-black text-5xl md:text-6xl text-ink mx-8 whitespace-nowrap flex items-center gap-8"
          >
            {w}
            <span className="text-hot">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
